<template>
  <div class="login-container">
      <div class="title-container">
        <img src="https://al3.acc5.com/179227_62a98518324c00.png">
      </div>
      <div class="login-form">
        <el-form :model="ruleForm" ref="ruleForm" :rules="ruleFormRules" label-width="0">
          <el-form-item prop="username" label="" :rules="[{ required: true, message: '请输入账号', trigger: 'blur' }]">
            <el-input v-model="ruleForm.username" prefix-icon="el-icon-user" placeholder="请输入账号"></el-input>
          </el-form-item>
          <el-form-item prop="password" label="" :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]">
            <el-input type="password"  v-model="ruleForm.password" show-password prefix-icon="el-icon-lock" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="13">
              <el-form-item prop="vercode" label="" :rules="[{ required: true, message: '请输入图形验证码', trigger: 'blur' }]">
                <el-input v-model="ruleForm.vercode" prefix-icon="el-icon-tickets" @keyup.enter.native="handleLogin" placeholder="请输入验证码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
                <img
                  title="点击更换图形验证码"
                  class="login-codeimg"
                  :src="captchaUrl"
                  @click="getCaptcha()"
                />
            </el-col>
          </el-row>
          <el-row>
          <div class="wx-work-login" title="企业微信扫码登录" @click="openLoginWxWork">
            <img src="https://al3.acc5.com/179227_62eb2d891616a0.png" width="30"> 企业微信扫码登录
          </div>
          </el-row>
          <el-button
            :loading="loading"
            type="primary"
            style="width:100%;margin-top: 40px;"
            @click.native.prevent="handleLogin"
          >登录</el-button>
        </el-form>
      </div>
  </div>
</template>
<script>
import { generateCode,doLogin,verifyUser,get_login_wx_work } from "@/api/user";
export default {
  data() {
    return {
      ruleForm: {
        key:""
      },
      ruleFormRules: {},
      loading: false,
      captchaUrl: 'https://static.acc5.com/static_acc5/images/2015/tk_bg.jpg',
    }
  },
  created () {
    if (this.$route.query.access_token) {
        localStorage.setItem("access_token", decodeURIComponent(this.$route.query.access_token));
        this.openLink()
        this.$message({message: '登录成功',type: 'success'});
    }
    if (this.$route.query.error_msg) {
      this.$alert(this.$route.query.error_msg, '温馨提示', {type: "error",confirmButtonText: '我知道了',showClose:false,lockScroll:false,callback: action => {
        this.$router.replace({query:{}})
      }});
    }
    this.doVerifyUser();
    if(!localStorage.getItem('access_token')){
      this.getCaptcha();
    }
  },
  methods: {
    //验证 是否存在有效用户！
    doVerifyUser(){
      if(localStorage.getItem('access_token')){
        verifyUser().then(res => {
          if (res && res.code === 200) {
            this.openLink()
          }else if(res && res.code === 403){
            localStorage.removeItem('access_token');
            this.getCaptcha();
          }else{
            this.getCaptcha(); // 401 405 不弹窗 直接显示验证码
          }
        })
      }
    },
    getCaptcha: function () {
      generateCode().then(res => {
        if (res.data.key && res.data.img) {
          this.ruleForm.key = res.data.key;
          this.captchaUrl = res.data.img
        }
      })
    },
    async handleLogin () {
      await this.doVerifyUser()
      this.$refs.ruleForm.validate(valid => {
        if (valid && !this.loading) {
          this.loading = true
          doLogin(this.ruleForm).then(res => {
            if (res.code === 200 && res.data.access_token) {
                this.$message({message: '登录成功',type: 'success'});
                localStorage.setItem("access_token", res.data.access_token);
                if(res.data.qy_wechat_uid || this.$cookie.get('wxWorkBindTip')){
                  this.openLink()
                }else{
                  this.$alert("系统检测到当前账号未绑定企业微信，是否前往绑定？", "温馨提示", {
                    confirmButtonText: "去绑定",
                    cancelButtonText: "关闭提示（一个月内不再提醒）",
                    showCancelButton: true,
                    showClose:false,
                    type: "warning",
                  }).then(() => {
                    this.$router.push({path:'/',query: {opwxwork: 1,}})
                  }).catch(err => {
                    this.$cookie.set('wxWorkBindTip', '1', { expires: '1M' });
                    this.openLink()
                  });
                }
            }else{
              this.getCaptcha()
              this.$message({message: res.message,type: 'error'});
            }
            this.loading = false
          })
        }
      })
    },
    openLink(){
      // 2025年12月9日16:37:52 直接跳首页 不接受 link_type 参数
      // let linkType = this.$route.query.link_type
      // if(linkType){
      //   let urlStr = ""
      //   let isCom = location.href.includes('sso.acc5.com')
      //   if(linkType == 1){
      //     urlStr = isCom ? "https://youqian.acc5.com/nhtml/#/login" : "https://youqianacc5.kjxt.com/nhtml/#/login"
      //   }else if(linkType == 2){
      //     urlStr = isCom ? "https://data.acc5.com/#/login" :"https://data.kjxt.com/#/login"
      //   }else if(linkType == 3){
      //     urlStr = isCom ? "https://dc.acc5.com/education/#/login" : "https://dcacc5.kjxt.com/education/#/login"
      //   }else if(linkType == 4){
      //     urlStr = "http://192.168.31.184:9528/#/login"
      //   }else if(linkType == 5){
      //     urlStr = "http://192.168.31.184:8080/#/login"
      //   }
      //   location.href = urlStr+'?access_token=' + encodeURIComponent(localStorage.getItem('access_token'))
      // }else{
      // }
      this.$router.push({path:'/'})
    },
    openLoginWxWork(){
      get_login_wx_work({muid:this.ruleForm.muid,redirect_url:location.href}).then(res=>{
        if(res.code==200){
          this.$alert('<iframe src="'+res.data+'" frameborder="0" style="width: 380px;height: 380px;"></iframe>', '企业微信扫码登录', {
            dangerouslyUseHTMLString: true,
            lockScroll:false,
            showConfirmButton:false
          });
        }else{
          this.$message.error(res.message);
        }
      })
    },
  }
}
</script>
<style scoped>
.login-container{position: absolute;left: 0;bottom: 0;top: 0;right: 0; background-image: url(https://al3.acc5.com/179227_62a985187aa310.png);background-size: cover;}
.login-container .title-container{padding-top: 4%;}
.login-form{display: inline-block;padding-left: 80px;padding-right: 80px; width: 320px;height: 380px;background-color: rgba(4, 18, 63, .8);}
.login-form form{margin-top: 60px;}
.login-codeimg{float: right;width: 133px; height: 40px;border-radius: 4px;cursor: pointer;}
.wx-work-login{position: absolute;width: 100%; cursor: pointer;text-align: center;color: #fff;font-size: 14px;}
.wx-work-login img{vertical-align: middle;}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue